import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import Warning from "../../../assets/images/icons/warning.svg";
import { filterBusinessAction } from "../../../redux/business/businessActions";

export default function FilterBusinessDropDown(props) {
  const { payLoad, isFilterOpen, setFilterState } = props;
  const dispatch = useDispatch();
  const { isLoading, filtering } = useSelector((state) => state.feature);

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    business_name: "",
    business_phone: "",
    business_city: "",
    start_date: "",
    end_date: "",
  });
  const { business_name, business_phone, business_city, start_date, end_date } =
    data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleReset = async () => {
    setData({
      business_name: "",
      business_phone: "",
      business_city: "",
      start_date: "",
      end_date: "",
    });
    await dispatch(filterBusinessAction(payLoad, 1));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);

    if (
      business_name ||
      business_phone ||
      business_city ||
      start_date ||
      end_date
    ) {
      setErrorMsg(false);
      try {
        const response = await dispatch(filterBusinessAction(data, 1));
        if (response?.status === "success") {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div data-test="couponModal">
      <form className="py-5 mt-4 px-5">
        <div className="grid grid-cols-1">
          <Input.Label
            title={"Business Name"}
            name="business_name"
            id="business_name"
            value={business_name}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter Business Name"
            onChange={handleChange}
          />
          <Input.Label
            title={"Business Phone"}
            name="business_phone"
            type={"tel"}
            id="business_phone"
            value={business_phone}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter Business Phone"
            onChange={handleChange}
          />
          <Input.Label
            title={"Business City"}
            name="business_city"
            id="business_city"
            value={business_city}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter Business City"
            onChange={handleChange}
          />

          <Input.DatePicker
            title={"Start Date"}
            name="start_date"
            id="start_date"
            htmlFor={"start_date"}
            defaultValue={start_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
          <Input.DatePicker
            title={"End Date"}
            name="end_date"
            id="end_date"
            htmlFor={"end_date"}
            defaultValue={end_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
        </div>
        <div className="py-8 grid grid-cols-2 gap-6 text-center">
          <Button.Secondary
            disabled={isLoading}
            title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
            className="px-4"
            onClick={handleReset}
            type="button"
          />
          <Button.Primary
            disabled={filtering}
            title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
            className="px-4"
            onClick={handleSubmit}
            type="button"
          />
        </div>
        {errorMsg && (
          <div className="flex gap-1 -mt-2">
            <img src={Warning} alt="warning" />
            <p>No value to filter by</p>
          </div>
        )}
      </form>
    </div>
  );
}
